export const INFO_STEP_LABEL = 'Enter Order Info';
export const SAMPLES_STEP_LABEL = 'Add Samples';
export const SAMPLES_SCIENCE_INFO_STEP_LABEL = 'Add Science Info';
export const SLIDES_STEP_LABEL = 'Specify Slides';
export const PRICE_REVIEW_STEP_LABEL = 'Item Review';
export const BILLING_STEP_LABEL = 'Billing, Shipping and Additionals';
export const REVIEW_STEP_LABEL = 'Review';
